import useAddProduct from "hooks/useAddProduct";
import { MdClose, MdDelete } from "react-icons/md";
import ReactQuill from "react-quill-new";
import "react-quill/dist/quill.snow.css";

const ProductModal = ({ toggleAddProduct, showAddProduct, onProductAdded }) => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    isFeatured,
    setIsFeatured,
    isPercentage,
    handlePercentageInput,
    bannerImages,
    setBannerImages,
    productimages,
    setProductImages,
    categories,
    sizes,
    setSizes,
    colors,
    setColors,
    colorImages,
    handleColorImageChange,
    handleRemoveColorImage,
    specsField,
    selectedSpecs,
    specInputs,
    handleAddSpecification,
    handleRemoveSpecification,
    handleImageChange,
    handleRemoveImage,
    closingModal,
    setSpecInputs,
    loading,
    isBestSelling,
    setIsBestSelling,
  } = useAddProduct(toggleAddProduct, onProductAdded);

  return (
    <>
      <div
        className="fixed inset-0 z-40 bg-navy-900 opacity-50"
        onClick={toggleAddProduct}
      ></div>

      <div
        className={`fixed right-0 top-0 h-screen w-2/3 transform bg-white transition-transform ${
          showAddProduct ? "translate-x-0" : "translate-x-full"
        } z-50 shadow-lg`}
      >
        <div className="flex h-full flex-col bg-navy-700">
          <div className="flex items-center justify-between bg-primary p-3 shadow-md">
            <div className="flex-col">
              <h1 className="text-2xl font-bold text-white">Add Product</h1>
              <h1 className="text-base text-white">
                Add your product and necessary information from here
              </h1>
            </div>
            <MdClose
              className="cursor-pointer rounded-full bg-navy-900 p-1 text-3xl text-white"
              onClick={closingModal}
            />
          </div>

          <form
            onSubmit={handleSubmit}
            encType="multipart/form-data"
            className="no-scrollbar h-full flex-col items-center overflow-y-scroll p-5"
          >
            <div>
              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">Is Featured</h1>
                <div className="flex items-center">
                  <label className="relative inline-flex cursor-pointer items-center">
                    <input
                      type="checkbox"
                      className="sr-only text-white"
                      checked={isFeatured}
                      onChange={() => setIsFeatured(!isFeatured)}
                    />
                    <div
                      className={`h-6 w-12 rounded-full transition-colors ${
                        isFeatured ? "bg-primary" : "bg-gray-300"
                      }`}
                    ></div>
                    <div
                      className={`absolute left-1 top-1 h-4 w-4 transform rounded-full bg-white transition-transform ${
                        isFeatured ? "translate-x-6" : "translate-x-0"
                      }`}
                    ></div>
                  </label>
                  <span className="ml-3 text-sm text-white">
                    {isFeatured ? "Featured" : "Not Featured"}
                  </span>
                </div>
              </div>
              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">Is Best Selling</h1>
                <div className="flex items-center">
                  <label className="relative inline-flex cursor-pointer items-center">
                    <input
                      type="checkbox"
                      className="sr-only text-white"
                      checked={isBestSelling}
                      onChange={() => setIsBestSelling(!isBestSelling)}
                    />
                    <div
                      className={`h-6 w-12 rounded-full transition-colors ${
                        isBestSelling ? "bg-primary" : "bg-gray-300"
                      }`}
                    ></div>
                    <div
                      className={`absolute left-1 top-1 h-4 w-4 transform rounded-full bg-white transition-transform ${
                        isBestSelling ? "translate-x-6" : "translate-x-0"
                      }`}
                    ></div>
                  </label>
                  <span className="ml-3 text-sm text-white">
                    {isBestSelling ? "Best Selling" : "Not Enabled"}
                  </span>
                </div>
              </div>
              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">
                  Product Title/Name *
                </h1>
                <input
                  className="w-3/5 rounded-md p-2"
                  type="text"
                  placeholder="Product Title/Name"
                  {...register("productName", { required: true })}
                />
              </div>
              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">
                  Highlighted Product Text
                </h1>
                <ReactQuill
                  className="text-black w-3/5 rounded-md bg-white p-2"
                  placeholder="Highlighted Product Text"
                  value={watch("productHighlightedText")}
                  onChange={(content, delta, source, editor) => {
                    setValue("productHighlightedText", editor.getHTML());
                  }}
                />
              </div>

              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">
                  Product Description
                </h1>
                <ReactQuill
                  className="text-black w-3/5 rounded-md bg-white p-2"
                  placeholder="Product Description"
                  value={watch("productDescription")}
                  onChange={(content, delta, source, editor) => {
                    setValue("productDescription", editor.getHTML());
                  }}
                />
              </div>

              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">Sizes</h1>
                <input
                  className="w-3/5 rounded-md p-2"
                  type="text"
                  placeholder="Enter sizes (comma separated)"
                  value={sizes.join(",")}
                  onChange={(e) => setSizes(e.target.value.split(","))}
                />
              </div>

              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">Colors</h1>
                <input
                  className="w-3/5 rounded-md p-2"
                  type="text"
                  placeholder="Enter colors (comma separated)"
                  value={colors.join(",")}
                  onChange={(e) => setColors(e.target.value.split(","))}
                />
              </div>
            </div>

            {colors.map((color, index) => (
              <div key={index} className="mb-5">
                <h1 className="text-lg text-white">Images for {color}</h1>
                <input
                  className="rounded-md p-2 text-white"
                  type="file"
                  multiple
                  accept=".jpeg, .jpg, .png .gif .mp4 .mov .webm .mkv"
                  onChange={(e) => handleColorImageChange(e, color)}
                  required
                />
                <div className="mt-2 flex flex-wrap gap-2">
                  {colorImages[color]?.map((file, fileIndex) => (
                    <div key={fileIndex} className="relative">
                      <img
                        src={file.preview}
                        alt="preview"
                        style={{ width: "100px", height: "100px" }}
                      />
                      <MdDelete
                        className="absolute right-0 top-0 cursor-pointer rounded-full bg-red-500 p-1 text-xl text-white"
                        onClick={() => handleRemoveColorImage(color, fileIndex)}
                      />
                    </div>
                  ))}
                </div>
              </div>
            ))}

            <div className="mb-5">
              <h1 className="text-lg text-white">Additional Images</h1>
              <input
                className="rounded-md p-2 text-white"
                type="file"
                multiple
                accept=".jpeg, .jpg, .png .gif .mp4 .mov .webm .mkv"
                onChange={(e) => handleImageChange(e, setProductImages)}
              />
              <div className="mt-2 flex flex-wrap gap-2">
                {productimages.map((file, index) => (
                  <div key={index} className="relative">
                    <img
                      src={file.preview}
                      alt="preview"
                      style={{ width: "100px", height: "100px" }}
                    />
                    <MdDelete
                      className="absolute right-0 top-0 cursor-pointer rounded-full bg-red-500 p-1 text-xl text-white"
                      onClick={() =>
                        handleRemoveImage(
                          index,
                          setProductImages,
                          productimages
                        )
                      }
                    />
                  </div>
                ))}
              </div>
            </div>

            <div>
              <div className="mb-5">
                <h1 className="text-lg text-white">Selected Specifications</h1>
                <div className="flex flex-wrap gap-2">
                  {selectedSpecs.map((spec) => (
                    <div
                      key={spec}
                      className="flex items-center rounded-md bg-gray-200 p-2"
                    >
                      <span>{spec}</span>
                      <MdClose
                        className="ml-2 cursor-pointer text-red-500"
                        onClick={() => handleRemoveSpecification(spec)}
                      />
                    </div>
                  ))}
                </div>
              </div>

              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">
                  Add Product Specifications
                </h1>
                <select
                  className="w-3/5 rounded-md p-2"
                  onChange={handleAddSpecification}
                  value=""
                >
                  <option value="">Select a Specification</option>
                  {specsField
                    .filter((spec) => !selectedSpecs.includes(spec))
                    .map((spec) => (
                      <option key={spec} value={spec}>
                        {spec}
                      </option>
                    ))}
                </select>
              </div>

              {selectedSpecs.map((spec) => (
                <div
                  key={spec}
                  className="mb-5 flex w-full items-center justify-between"
                >
                  <h1 className="w-2/5 text-lg text-white">{spec}</h1>
                  <input
                    className="w-3/5 rounded-md p-2"
                    type="text"
                    placeholder={`Enter ${spec}`}
                    value={specInputs[spec] || ""}
                    onChange={(e) =>
                      setSpecInputs({
                        ...specInputs,
                        [spec]: e.target.value,
                      })
                    }
                  />
                </div>
              ))}
              <div />

              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">
                  Product SKU (unique)
                </h1>
                <input
                  className="w-3/5 rounded-md p-2"
                  type="text"
                  placeholder="Product SKU"
                  {...register("productSKU")}
                />
              </div>
              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">
                  Product IMEI LIST (unique and comma separated)
                </h1>
                <input
                  className="w-3/5 rounded-md p-2"
                  type="text"
                  placeholder="Product IMEI"
                  {...register("product_imei_list")}
                />
              </div>
              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">Product Category *</h1>
                <select
                  className="w-3/5 rounded-md p-2"
                  {...register("productCategory", { required: true })}
                >
                  <option value="">Select a Category</option>
                  {categories.map((category) => (
                    <option key={category.id} value={category.id}>
                      {category.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">
                  Product Price <span>(Customer) *</span>
                </h1>
                <input
                  className="w-3/5 rounded-md p-2"
                  type="number"
                  placeholder="$"
                  {...register("customerPrice", { required: true })}
                />
              </div>

              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">
                  Use Percentage For (Retailer, Distributor, Corporate Clients)
                </h1>
                <div className="flex w-3/5 items-center">
                  <label className="relative inline-flex cursor-pointer items-center">
                    <input
                      type="checkbox"
                      className="sr-only text-white"
                      checked={isPercentage}
                      onChange={handlePercentageInput}
                    />
                    <div
                      className={`h-6 w-12 rounded-full transition-colors ${
                        isPercentage ? "bg-primary" : "bg-gray-300"
                      }`}
                    ></div>
                    <div
                      className={`absolute left-1 top-1 h-4 w-4 transform rounded-full bg-white transition-transform ${
                        isPercentage ? "translate-x-6" : "translate-x-0"
                      }`}
                    ></div>
                  </label>
                  <span className="ml-3 text-sm text-white">
                    {isPercentage ? "Enabled" : "Disabled"}
                  </span>
                </div>
              </div>

              {isPercentage ? (
                <>
                  <div className="mb-5 flex w-full items-center justify-between">
                    <h1 className="w-2/5 text-lg text-white">
                      Product Price Percentage (Retailer)
                    </h1>
                    <input
                      className="w-3/5 rounded-md p-2"
                      type="number"
                      placeholder="$"
                      {...register("retailerPercentage")}
                    />
                  </div>
                  <div className="mb-5 flex w-full items-center justify-between">
                    <h1 className="w-2/5 text-lg text-white">
                      Product Price Percentage (Distributor)
                    </h1>
                    <input
                      className="w-3/5 rounded-md p-2"
                      type="number"
                      placeholder="$"
                      {...register("distributorPercentage")}
                    />
                  </div>
                  <div className="mb-5 flex w-full items-center justify-between">
                    <h1 className="w-2/5 text-lg text-white">
                      Product Price Percentage (Corporate Clients)
                    </h1>
                    <input
                      className="w-3/5 rounded-md p-2"
                      type="number"
                      placeholder="$"
                      {...register("corporatePercentage")}
                    />
                  </div>
                </>
              ) : (
                <>
                  <div className="mb-5 flex w-full items-center justify-between">
                    <h1 className="w-2/5 text-lg text-white">
                      Product Price <span>(Retailer)</span>
                    </h1>
                    <input
                      className="w-3/5 rounded-md p-2"
                      type="number"
                      placeholder="$"
                      {...register("retailerPrice")}
                    />
                  </div>
                  <div className="mb-5 flex w-full items-center justify-between">
                    <h1 className="w-2/5 text-lg text-white">
                      Product Price <span>(Distributor) </span>
                    </h1>
                    <input
                      className="w-3/5 rounded-md p-2"
                      type="number"
                      placeholder="$"
                      {...register("distributorPrice")}
                    />
                  </div>
                  <div className="mb-5 flex w-full items-center justify-between">
                    <h1 className="w-2/5 text-lg text-white">
                      Product Price <span>(Corporate Clients) </span>
                    </h1>
                    <input
                      className="w-3/5 rounded-md p-2"
                      type="number"
                      placeholder="$"
                      {...register("corporateClientPrice")}
                    />
                  </div>
                </>
              )}

              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">Product Quantity *</h1>
                <input
                  className="w-3/5 rounded-md p-2"
                  type="number"
                  placeholder="$"
                  {...register("quantity", { required: true })}
                />
              </div>
              <div className="mb-5 flex w-full items-center justify-between">
                <h1 className="w-2/5 text-lg text-white">Product Discount</h1>
                <input
                  className="w-3/5 rounded-md p-2"
                  type="number"
                  placeholder="$"
                  {...register("productDiscount")}
                />
              </div>

              <div className="mb-5">
                <h1 className="text-lg text-white">Banner Photo</h1>
                <input
                  className="rounded-md p-2 text-white"
                  type="file"
                  multiple
                  accept=".jpeg, .jpg, .png .gif .mp4 .mov .webm .mkv"
                  onChange={(e) => handleImageChange(e, setBannerImages)}
                />
                <div className="mt-2 flex flex-wrap gap-2">
                  {bannerImages.map((file, index) => (
                    <div key={index} className="relative">
                      <img
                        src={file.preview}
                        alt="preview"
                        style={{ width: "100px", height: "100px" }}
                      />
                      <MdDelete
                        className="absolute right-0 top-0 cursor-pointer rounded-full bg-red-500 p-1 text-xl text-white"
                        onClick={() =>
                          handleRemoveImage(
                            index,
                            setBannerImages,
                            bannerImages
                          )
                        }
                      />
                    </div>
                  ))}
                </div>
                <div className="mt-2 flex flex-wrap gap-2">
                  <button
                    type="submit"
                    className="w-full rounded-md bg-primary p-2 text-lg text-primaryText"
                    disabled={loading}
                  >
                    {loading ? "Adding Product..." : "Add Product"}
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default ProductModal;
